/*
 * @Author: your name
 * @Date: 2020-09-15 09:15:12
 * @LastEditTime: 2020-11-25 16:40:26
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath:
 */
import axios from 'axios'
import _this from '@/main.js'
import {
  Notification
} from 'element-ui'
import router from '@/project/router'
// create axios instance
let instance = null

if (process.env.NODE_ENV === 'development') {
  instance = axios.create({
    baseURL: '/' // api context
  })
} else {
  // 生产环境下
  instance = axios.create({
    baseURL: 'https://www.kundagroup.com.au/' // api context
  })
}

instance.defaults.timeout = 50000 // timeout

// request interceptors
instance.interceptors.request.use(
  // request => {
  //   return request;
  // },
  config => {
    // if (localStorage.getItem('token')) {
    //   config.headers['Access-Token'] = localStorage.getItem('token')
    // }
    // if (_this.$store.state.token) {
    //   config.headers['Access-Token'] = _this.$store.state.token;
    // }

    config.headers['Content-Type'] = _this.$store.state.formUrlEncoded || 'application/json'

    return config
  },
  error => {
    // Do something with request error
    console.log('request', error)
    Notification({
      title: '错误',
      message: '这是一条错误的提示消息',
      type: 'error'
    })
    Promise.reject(error)
  }
)

// response interceptors response data format {code: 200, data: {}} or {code: 400, message: "error"}
instance.interceptors.response.use(response => {
  // 这一步是对响应返回数据的拦截，在数据返回之前先把返回结果指向了data
  let res = { data: response.data.data, status: response.status, response }
  // let code = res.code
  return res

  // if (code) {
  //   if (res.code === 200) {
  //
  //     let data = res.data
  //     if (data === undefined || data === '' || data === null) {
  //       data = 0
  //     }
  //     return data
  //   } else if (res.code === 401 || (res.code === 407 && res.message === `Token expired or does not exist`)) {
  //
  //     // handle token is expired
  //     // Notification({
  //     //   title: '警告',
  //     //   message: `已在别处登录，请重新登录`, //`已在别处登录，token失效，请重新登录`
  //     //   type: 'warning'
  //     // })
  //     // router.push('/login')
  //   } else {
  //
  //     // handle code is not 200
  //     if (res.code === 500 && res.message === '密码错误') {
  //       res.message = '原密码错误'
  //     }
  //
  //     Notification({
  //       title: '警告',
  //       message: res.message,
  //       type: 'warning'
  //     })
  //   }
  // }
})

export default instance



// WEBPACK FOOTER //
// ./src/framework/http/axios.js